/* ==========================================================================
   FLORA · comportamiento de la plantilla "landing-flora"
   JavaScript puro, sin dependencias. Piezas:
     - Revelado al hacer scroll         ([data-flora-reveal])
     - Videos con carga y play perezosos ([data-flora-video]) + botón de sonido
     - <flora-gallery>   galería con miniaturas, puntos y visor ampliado
     - <flora-product>   selector de variantes / tarjetas de oferta / precio / botón
     - <flora-accordion> acordeón animado
     - <flora-carousel>  carrusel con puntos y flechas
     - Ventanas modales  ([data-flora-open] / [data-flora-close])
   ========================================================================== */
(function () {
  'use strict';
  if (window.__floraLoaded) return;
  window.__floraLoaded = true;

  var doc = document;
  var root = doc.documentElement;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function px(value) { var n = parseFloat(value); return isNaN(n) ? 0 : n; }

  /* ---------- Revelado al hacer scroll ---------- */
  var revealIO = null;
  function initReveal(scope) {
    var els = toArray((scope || doc).querySelectorAll('[data-flora-reveal]:not([data-flora-seen])'));
    if (!els.length) return;
    if (designMode) root.classList.add('flora-design');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.setAttribute('data-flora-seen', ''); el.classList.add('is-in'); });
      return;
    }
    root.classList.add('flora-js');
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealIO.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    els.forEach(function (el) { el.setAttribute('data-flora-seen', ''); revealIO.observe(el); });
  }

  /* ---------- Videos ---------- */
  var videoIO = null;
  function loadVideo(video) {
    if (video.getAttribute('data-flora-loaded')) return;
    toArray(video.querySelectorAll('source[data-src]')).forEach(function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });
    video.setAttribute('data-flora-loaded', '1');
    video.load();
  }
  function playVideo(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
  function initVideos(scope) {
    var videos = toArray((scope || doc).querySelectorAll('video[data-flora-video]:not([data-flora-vseen])'));
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.setAttribute('data-flora-vseen', ''); loadVideo(v); playVideo(v); });
      return;
    }
    if (!videoIO) {
      videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            loadVideo(video);
            if (!reduced) playVideo(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
    }
    videos.forEach(function (v) {
      v.setAttribute('data-flora-vseen', '');
      if (reduced) v.controls = true;
      videoIO.observe(v);
    });
  }

  function syncSound(button, video) {
    var on = !video.muted;
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute('aria-label', on ? 'Silenciar' : 'Activar sonido');
  }
  doc.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-flora-sound]');
    if (!button) return;
    var media = button.closest('.flora-media');
    var video = media && media.querySelector('video');
    if (!video) return;
    var turnOn = video.muted;
    toArray(doc.querySelectorAll('video[data-flora-video]')).forEach(function (other) {
      if (other === video) return;
      other.muted = true;
      var otherBtn = other.closest('.flora-media') && other.closest('.flora-media').querySelector('[data-flora-sound]');
      if (otherBtn) syncSound(otherBtn, other);
    });
    video.muted = !turnOn;
    if (turnOn) {
      loadVideo(video);
      var played = video.play();
      // si el navegador no permite reproducir con sonido, se vuelve a silenciar
      if (played && typeof played.catch === 'function') {
        played.catch(function () { video.muted = true; syncSound(button, video); });
      }
    }
    syncSound(button, video);
  });

  /* ---------- Modales (<dialog>) ---------- */
  doc.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-flora-open]');
    if (opener) {
      var dialog = doc.querySelector(opener.getAttribute('data-flora-open'));
      if (dialog && typeof dialog.showModal === 'function') { event.preventDefault(); dialog.showModal(); }
      return;
    }
    var closer = event.target.closest && event.target.closest('[data-flora-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }
    // clic sobre el fondo oscuro (el propio <dialog>) cierra la ventana
    if (event.target.tagName === 'DIALOG' && event.target.hasAttribute('data-flora-dialog')) event.target.close();
  });

  /* ---------- Galería ---------- */
  function slideLeft(track, slide) {
    var pad = px(window.getComputedStyle(track).scrollPaddingLeft);
    return slide.offsetLeft - pad;
  }

  if (!customElements.get('flora-gallery')) {
    customElements.define('flora-gallery', class FloraGallery extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = toArray(this.track.querySelectorAll('.flora-gallery__slide'));
        this.thumbs = toArray(this.querySelectorAll('[data-thumb]'));
        this.dotsBox = this.querySelector('[data-dots]');
        this.lightbox = this.querySelector('[data-lightbox]');
        this.index = 0;

        if (this.dotsBox && this.slides.length > 1) {
          this.dots = this.slides.map(function (_, i) {
            var dot = doc.createElement('button');
            dot.type = 'button';
            dot.className = 'flora-gallery__dot';
            dot.setAttribute('aria-label', 'Imagen ' + (i + 1));
            this.dotsBox.appendChild(dot);
            dot.addEventListener('click', function () { this.goTo(i); }.bind(this));
            return dot;
          }, this);
        }
        this.thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { this.goTo(i); }.bind(this)); }, this);

        var prev = this.querySelector('[data-prev]');
        var next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { this.goTo(this.index - 1); }.bind(this));
        if (next) next.addEventListener('click', function () { this.goTo(this.index + 1); }.bind(this));

        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () { ticking = false; this.syncFromScroll(); }.bind(this));
        }.bind(this), { passive: true });

        if (this.hasAttribute('data-zoom') && this.lightbox) {
          this.slides.forEach(function (slide, i) {
            var opener = slide.querySelector('[data-zoom-open]');
            if (opener) opener.addEventListener('click', function () { this.openLightbox(i); }.bind(this));
          }, this);
          var lbPrev = this.lightbox.querySelector('[data-lb-prev]');
          var lbNext = this.lightbox.querySelector('[data-lb-next]');
          if (lbPrev) lbPrev.addEventListener('click', function () { this.stepLightbox(-1); }.bind(this));
          if (lbNext) lbNext.addEventListener('click', function () { this.stepLightbox(1); }.bind(this));
          this.lightbox.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') this.stepLightbox(-1);
            if (e.key === 'ArrowRight') this.stepLightbox(1);
          }.bind(this));
        }
        this.setActive(0);
      }

      zoomable() {
        return this.slides.filter(function (s) { return s.getAttribute('data-zoom-src'); });
      }
      openLightbox(slideIndex) {
        var list = this.zoomable();
        var pos = list.indexOf(this.slides[slideIndex]);
        if (pos < 0) return;
        this.lbPos = pos;
        this.paintLightbox();
        this.lightbox.showModal();
      }
      stepLightbox(step) {
        var list = this.zoomable();
        if (!list.length) return;
        this.lbPos = (this.lbPos + step + list.length) % list.length;
        this.paintLightbox();
      }
      paintLightbox() {
        var list = this.zoomable();
        var slide = list[this.lbPos];
        var img = this.lightbox.querySelector('[data-lb-img]');
        if (!slide || !img) return;
        img.src = slide.getAttribute('data-zoom-src');
        img.alt = slide.getAttribute('data-zoom-alt') || '';
        var multiple = list.length > 1;
        toArray(this.lightbox.querySelectorAll('[data-lb-prev],[data-lb-next]')).forEach(function (b) { b.hidden = !multiple; });
      }

      goTo(i) {
        if (!this.slides.length) return;
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        var behavior = reduced ? 'auto' : 'smooth';
        this.track.scrollTo({ left: slideLeft(this.track, this.slides[i]), behavior: behavior });
        this.setActive(i);
      }
      goToMedia(mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < this.slides.length; i++) {
          if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) { this.goTo(i); return; }
        }
      }
      syncFromScroll() {
        var left = this.track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < this.slides.length; i++) {
          var dist = Math.abs(slideLeft(this.track, this.slides[i]) - left);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        var atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        if (atEnd) best = this.slides.length - 1;
        if (best !== this.index) this.setActive(best);
      }
      setActive(i) {
        this.index = i;
        (this.dots || []).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        this.thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        var thumbsBox = this.querySelector('[data-thumbs]');
        var active = this.thumbs[i];
        if (thumbsBox && active && thumbsBox.scrollWidth > thumbsBox.clientWidth) {
          thumbsBox.scrollTo({ left: active.offsetLeft - thumbsBox.clientWidth / 2 + active.clientWidth / 2, behavior: reduced ? 'auto' : 'smooth' });
        }
      }
    });
  }

  /* ---------- Producto: variantes, tarjetas de oferta, precio, botón ---------- */
  if (!customElements.get('flora-product')) {
    customElements.define('flora-product', class FloraProduct extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var dataEl = this.querySelector('script[data-flora-data]');
        if (!dataEl) return;
        try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }
        this.variants = this.data.variants || [];
        this.current = this.variants.filter(function (v) { return v.id === this.data.selected; }, this)[0] || this.variants[0];
        if (!this.current) return;
        this.selected = this.current.opts.slice();
        this.addEventListener('change', this.onChange.bind(this));
        this.enableInputs();
      }

      enableInputs() {
        toArray(this.querySelectorAll('input[name="id"]')).forEach(function (input) { input.disabled = false; });
      }

      onChange(event) {
        var target = event.target;
        if (!target || target.getAttribute('data-option-index') === null) return;
        var index = parseInt(target.getAttribute('data-option-index'), 10);
        this.selected[index] = target.value;
        var match = this.find(this.selected);
        if (!match) {
          // combinación inexistente: tomar la primera variante (disponible) que tenga el valor elegido
          var candidates = this.variants.filter(function (v) { return v.opts[index] === target.value; });
          match = candidates.filter(function (v) { return v.available; })[0] || candidates[0];
          if (match) this.selected = match.opts.slice();
        }
        if (match) { this.current = match; this.render(); }
      }

      find(opts) {
        return this.variants.filter(function (v) {
          for (var i = 0; i < opts.length; i++) { if (v.opts[i] !== opts[i]) return false; }
          return true;
        })[0];
      }

      setText(selector, text, scope) {
        toArray((scope || this).querySelectorAll(selector)).forEach(function (el) { el.textContent = text; });
      }

      captionFor(template, variant) {
        if (!template) return '';
        // si el texto usa [ahorro] y esta variante no tiene descuento, la etiqueta se oculta entera
        var usesSaving = /\[ahorro(_monto)?\]/.test(template);
        if (usesSaving && !variant.pct) return '';
        return template.replace(/\[ahorro\]/g, variant.pct + '%')
          .replace(/\[ahorro_monto\]/g, variant.saved || '')
          .replace(/\s{2,}/g, ' ').trim();
      }

      render() {
        var v = this.current;
        // 1) input oculto del formulario nativo (Releasit y el carrito del tema leen este valor)
        toArray(this.querySelectorAll('input[name="id"]')).forEach(function (input) {
          input.value = v.id;
          input.disabled = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        // 2) precios
        this.setText('[data-flora-price]', v.price);
        toArray(this.querySelectorAll('[data-flora-compare]')).forEach(function (el) {
          el.textContent = v.compare;
          el.hidden = !v.compare;
        });
        toArray(this.querySelectorAll('[data-flora-save]')).forEach(function (el) {
          var template = el.getAttribute('data-template') || 'Ahorras [ahorro]';
          var text = v.pct ? this.captionFor(template, v) : '';
          el.textContent = text;
          el.hidden = !text;
        }, this);
        // 3) botones de compra
        toArray(this.querySelectorAll('[data-flora-buy]')).forEach(function (btn) {
          btn.disabled = !v.available;
          var label = btn.querySelector('[data-flora-buy-label]');
          if (label) label.textContent = v.available ? (btn.getAttribute('data-label') || '') : (btn.getAttribute('data-soldout') || 'Agotado');
          var price = btn.querySelector('[data-flora-buy-price]');
          if (price) price.textContent = v.available && btn.hasAttribute('data-show-price') ? v.price + ' • ' : '';
        });
        // 4) tarjetas de oferta
        var cardOpt = this.data.cardOption;
        toArray(this.querySelectorAll('.flora-offer')).forEach(function (card) {
          var value = card.getAttribute('data-value');
          var opts = this.selected.slice();
          if (cardOpt !== null && cardOpt !== undefined) opts[cardOpt] = value;
          // combinación inexistente = tarjeta no disponible (nunca mostrar el precio de otro color/variante)
          var cv = this.find(opts);
          var input = card.querySelector('input');
          var isSel = cv && cv.id === v.id;
          card.classList.toggle('is-selected', !!isSel);
          card.classList.toggle('is-missing', !cv);
          if (input) { input.checked = !!isSel; input.disabled = !cv; }
          if (!cv) {
            card.classList.add('is-soldout');
            this.setText('[data-card-price]', '—', card);
            var missCmp = card.querySelector('[data-card-compare]');
            var missTag = card.querySelector('[data-card-tag]');
            if (missCmp) missCmp.hidden = true;
            if (missTag) missTag.hidden = true;
            return;
          }
          card.classList.toggle('is-soldout', !cv.available);
          this.setText('[data-card-price]', cv.price, card);
          var cmp = card.querySelector('[data-card-compare]');
          if (cmp) { cmp.textContent = cv.compare; cmp.hidden = !cv.compare; }
          var tag = card.querySelector('[data-card-tag]');
          if (tag) {
            var text = this.captionFor(tag.getAttribute('data-template'), cv);
            tag.textContent = text; tag.hidden = !text;
          }
          var img = card.querySelector('[data-card-img]');
          if (img && cv.img && img.getAttribute('data-follow') === 'true') img.src = cv.img;
        }, this);
        // 5) opciones en pastillas: deshabilitar combinaciones inexistentes
        this.syncPills();
        // 6) galería
        var gallery = doc.querySelector('flora-gallery[data-section="' + this.getAttribute('data-section') + '"]');
        if (gallery && gallery.goToMedia && v.media) gallery.goToMedia(v.media);
        // 7) URL
        if (this.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        doc.dispatchEvent(new CustomEvent('flora:variant', { detail: { variant: v, product: this } }));
      }

      syncPills() {
        var self = this;
        toArray(this.querySelectorAll('.flora-opt')).forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          toArray(group.querySelectorAll('input')).forEach(function (input) {
            var opts = self.selected.slice();
            opts[idx] = input.value;
            var exists = self.variants.some(function (x) {
              return x.available && x.opts.every(function (val, k) { return k === idx ? val === input.value : true; }) &&
                x.opts.every(function (val, k) { return k === idx || val === opts[k]; });
            });
            // se tachan las combinaciones sin stock, pero siguen siendo clicables
            // (al elegirlas se busca la variante más cercana, como hace Shopify)
            input.checked = self.selected[idx] === input.value;
            if (input.parentElement) input.parentElement.classList.toggle('is-unavailable', !exists && !input.checked);
          });
        });
      }
    });
  }

  /* ---------- Acordeón ---------- */
  if (!customElements.get('flora-accordion')) {
    customElements.define('flora-accordion', class FloraAccordion extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.items = toArray(this.querySelectorAll('details.flora-acc__item'));
        this.exclusive = this.hasAttribute('data-exclusive');
        this.items.forEach(function (item) {
          var summary = item.querySelector('summary');
          if (!summary) return;
          summary.addEventListener('click', function (event) {
            event.preventDefault();
            this.toggle(item);
          }.bind(this));
        }, this);
      }
      toggle(item) {
        var isOpen = item.hasAttribute('open') && !item._closing;
        if (!isOpen && this.exclusive) {
          this.items.forEach(function (other) { if (other !== item && other.hasAttribute('open')) this.close(other); }, this);
        }
        if (isOpen) this.close(item); else this.open(item);
      }
      open(item) {
        var body = item.querySelector('.flora-acc__body');
        item._closing = false;
        if (item._anim) item._anim.cancel();
        item.setAttribute('open', '');
        if (!body || reduced || !body.animate) return;
        var height = body.scrollHeight;
        item._anim = body.animate([{ height: '0px' }, { height: height + 'px' }], { duration: 260, easing: 'ease' });
        item._anim.onfinish = function () { item._anim = null; };
      }
      close(item) {
        var body = item.querySelector('.flora-acc__body');
        if (!body || reduced || !body.animate) { item.removeAttribute('open'); return; }
        if (item._anim) item._anim.cancel();
        item._closing = true;
        var height = body.offsetHeight;
        item._anim = body.animate([{ height: height + 'px' }, { height: '0px' }], { duration: 220, easing: 'ease' });
        item._anim.onfinish = function () { item.removeAttribute('open'); item._closing = false; item._anim = null; };
      }
    });
  }

  /* ---------- Carrusel ---------- */
  if (!customElements.get('flora-carousel')) {
    customElements.define('flora-carousel', class FloraCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = toArray(this.track.children);
        this.dotsBox = this.querySelector('[data-dots]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.index = 0;
        if (this.dotsBox && this.slides.length > 1) {
          this.dots = this.slides.map(function (_, i) {
            var dot = doc.createElement('button');
            dot.type = 'button';
            dot.className = 'flora-car__dot';
            dot.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
            dot.addEventListener('click', function () { this.goTo(i); }.bind(this));
            this.dotsBox.appendChild(dot);
            return dot;
          }, this);
        }
        if (this.prev) this.prev.addEventListener('click', function () { this.step(-1); }.bind(this));
        if (this.next) this.next.addEventListener('click', function () { this.step(1); }.bind(this));
        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () { ticking = false; this.sync(); }.bind(this));
        }.bind(this), { passive: true });
        window.addEventListener('resize', function () { this.sync(); }.bind(this));
        this.sync();
      }
      goTo(i) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        this.track.scrollTo({ left: slideLeft(this.track, this.slides[i]), behavior: reduced ? 'auto' : 'smooth' });
      }
      step(dir) {
        var slide = this.slides[0];
        var gap = px(window.getComputedStyle(this.track).columnGap);
        var amount = (slide ? slide.getBoundingClientRect().width : this.track.clientWidth) + gap;
        this.track.scrollBy({ left: dir * amount, behavior: reduced ? 'auto' : 'smooth' });
      }
      sync() {
        var left = this.track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < this.slides.length; i++) {
          var dist = Math.abs(slideLeft(this.track, this.slides[i]) - left);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        var maxScroll = this.track.scrollWidth - this.track.clientWidth;
        var atStart = left <= 2;
        var atEnd = left >= maxScroll - 2;
        if (atEnd && maxScroll > 0) best = this.slides.length - 1;
        this.index = best;
        (this.dots || []).forEach(function (d, k) { d.classList.toggle('is-active', k === best); });
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd || maxScroll <= 0;
      }
    });
  }

  /* ---------- Texto corredizo: velocidad constante en píxeles por segundo ---------- */
  if (!customElements.get('flora-ticker')) {
    customElements.define('flora-ticker', class FloraTicker extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var group = this.querySelector('.flora-ticker__group');
        if (!group) return;
        var self = this;
        var apply = function () {
          var speed = parseFloat(self.getAttribute('data-speed')) || 5;
          var pxPerSecond = 20 + speed * 10; // velocidad 1..10 => 30..120 px/s
          var width = group.getBoundingClientRect().width;
          if (width > 0) self.style.setProperty('--tk-dur', (width / pxPerSecond).toFixed(2) + 's');
        };
        apply();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
        if ('ResizeObserver' in window) new ResizeObserver(apply).observe(group);
        else window.addEventListener('resize', apply);
      }
    });
  }

  /* ---------- Arranque y editor de temas ---------- */
  function init(scope) { initReveal(scope); initVideos(scope); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (event) { init(event.target); });
  doc.addEventListener('shopify:block:select', function (event) {
    // en el editor: mostrar el bloque seleccionado dentro de carruseles y galerías
    var el = event.target;
    var slide = el.closest && el.closest('.flora-car__slide, .flora-gallery__slide');
    var host = slide && slide.closest('flora-carousel, flora-gallery');
    if (!host) return;
    var track = host.querySelector('[data-track]');
    if (track) track.scrollTo({ left: slideLeft(track, slide), behavior: 'auto' });
  });
})();
